/**
 * Carrying a real session on a page served from localhost.
 *
 * The session cookie belongs to samsurveyor.com, so a page on localhost cannot
 * hold it. But sam-dbam already accepts the same token in an `Authorization:
 * Bearer` header, and `http://localhost:3004` is already on its allowed-origins
 * list. So a local page can hold a real, verified session without anything being
 * weakened anywhere: the service checks the signature against the same key set
 * and applies the same permission rules.
 *
 * The token lives in sessionStorage and dies with the tab. It is a bearer
 * credential — anyone holding it is you — so it is never written to
 * localStorage, never put in the address, and never logged.
 *
 * How to get one: sign in to Console as normal, open the browser console there,
 * and run `document.cookie.split('hanko=')[1].split(';')[0]`. Paste the result
 * into the bar at the top of this screen.
 */

const KEY = 'channels.session.token';

/** The token this tab is carrying, or empty string. */
export function getSessionToken() {
    try {
        return window.sessionStorage.getItem(KEY) || '';
    } catch (err) {
        return '';
    }
}

/** Remember a token for this tab only. Passing nothing forgets it. */
export function setSessionToken(token) {
    try {
        const trimmed = (token || '').trim();
        if (trimmed) window.sessionStorage.setItem(KEY, trimmed);
        else window.sessionStorage.removeItem(KEY);
    } catch (err) {
        /* private browsing can refuse storage; the screen still works without it */
    }
}
